<template>
  <div>
    <b-form-file v-model="file" :state="valid" placeholder="Upload a PDF..." accept="application/pdf" @input="onChange"></b-form-file>
    <div v-if="file" class="mt-2 small text-muted">{{ file.name }} ({{ humanSize }})</div>
  </div>
</template>

<script>
export default {
  name: 'LLMUpload',
  data() {
    return { file: null }
  },
  computed: {
    valid() { return this.file != null },
    humanSize() { if (!this.file) return ''; return (this.file.size/1024).toFixed(1) + ' KB' }
  },
  methods: {
    onChange() {
      this.$emit('file-selected', this.file)
    }
  }
}
</script>
